import { httpLink } from "@trpc/client";
import { createTRPCNext } from "@trpc/next";
import { AppRouter } from "trpc-server";
import superjson from "superjson";
import { queryClient } from "./queryClient";

export function getBaseUrl() {
    if (process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === "development") {
        return "https://api.accounting-dev.request.finance";
    }

    if (process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === "staging") {
        return "https://api.accounting-staging.request.finance";
    }

    if (process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === "production") {
        return "https://api.accounting.request.finance";
    }

    if (process.env.VERCEL_URL) {
        // reference for vercel.com
        return `https://${process.env.VERCEL_URL}`;
    }

    if (process.env.RENDER_INTERNAL_HOSTNAME) {
        // reference for render.com
        return `http://${process.env.RENDER_INTERNAL_HOSTNAME}:${process.env.PORT}`;
    }

    return "http://localhost:3000/api";
}

export const trpc = createTRPCNext<AppRouter>({
    config() {
        return {
            transformer: superjson,
            queryClient,
            links: [
                httpLink({
                    fetch: (url, options) => {
                        return fetch(url, {
                            ...options,
                            credentials: "include",
                        });
                    },
                    url: `${getBaseUrl()}/trpc`,
                }),
            ],
        };
    },
});
